import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as XLSX from "xlsx";
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

@Injectable({
	providedIn: "root"
})
export class UtilsProvider {

	constructor(
		private _snackBar: MatSnackBar
	) { }

	toast(options: any) {
		this._snackBar.open(options.message, options.action, {
			duration: options.duration || 6000,
		});
	}

	tryCatch(promise) {
		return promise.then(data => {
			return [null, data];
		})
			.catch(err => [err]);
	}
	getAlias(str) {
		const conversions = {

			ae: "ä|æ|ǽ",
			oe: "ö|œ",
			ue: "ü",
			Ae: "Ä",
			Ue: "Ü",
			Oe: "Ö",
			A: "À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ",
			a: "à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª",
			C: "Ç|Ć|Ĉ|Ċ|Č",
			c: "ç|ć|ĉ|ċ|č",
			D: "Ð|Ď|Đ",
			d: "ð|ď|đ",
			E: "È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě",
			e: "è|é|ê|ë|ē|ĕ|ė|ę|ě",
			G: "Ĝ|Ğ|Ġ|Ģ",
			g: "ĝ|ğ|ġ|ģ",
			H: "Ĥ|Ħ",
			h: "ĥ|ħ",
			I: "Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ",
			i: "ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı",
			J: "Ĵ",
			j: "ĵ",
			K: "Ķ",
			k: "ķ",
			L: "Ĺ|Ļ|Ľ|Ŀ|Ł",
			l: "ĺ|ļ|ľ|ŀ|ł",
			N: "Ñ|Ń|Ņ|Ň",
			n: "ñ|ń|ņ|ň|ŉ",
			O: "Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ",
			o: "ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º",
			R: "Ŕ|Ŗ|Ř",
			r: "ŕ|ŗ|ř",
			S: "Ś|Ŝ|Ş|Š",
			s: "ś|ŝ|ş|š|ſ",
			T: "Ţ|Ť|Ŧ",
			t: "ţ|ť|ŧ",
			U: "Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ",
			u: "ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ",
			Y: "Ý|Ÿ|Ŷ",
			y: "ý|ÿ|ŷ",
			W: "Ŵ",
			w: "ŵ",
			Z: "Ź|Ż|Ž",
			z: "ź|ż|ž",
			AE: "Æ|Ǽ",
			ss: "ß",
			IJ: "Ĳ",
			ij: "ĳ",
			OE: "Œ",
			f: "ƒ",
		};

		for (const i in conversions) {
			const re = new RegExp(conversions[i], "g");
			str = str.replace(re, i);
		}
		str = str.split(" ").join("_");

		return str;
	}
	groupBy(xs, key) {
		return xs.reduce((rv, x) => {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}
	orderBy(objs, prop) {
		return objs.sort((a, b) => {
			if (a[prop] < b[prop]) {
				return -1;
			}
			if (a[prop] > b[prop]) {
				return 1;
			}
			return 0;
		});
	}
	downloadFile(data, filename = "data") {
		// let csvData = this.convertToCSV(data, ['name','age', 'average', 'approved', 'description']);
		// console.log(csvData)
		const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
		const dwldLink = document.createElement("a");
		const url = URL.createObjectURL(blob);
		const isSafariBrowser = navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1;
		if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
			dwldLink.setAttribute("target", "_blank");
		}
		dwldLink.setAttribute("href", url);
		dwldLink.setAttribute("download", filename + ".xlsx");
		dwldLink.style.visibility = "hidden";
		document.body.appendChild(dwldLink);
		dwldLink.click();
		document.body.removeChild(dwldLink);
	}

	exportAsExcelFile(json: any[], excelFileName: string): void {
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
		const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
		const excelBuffer: any = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
		this.downloadFile(excelBuffer, excelFileName);
	}

	exportAsPDF(cols: string[], rows: any[], fileName: string): void {
		const doc = new jsPDF({
			orientation: "landscape"
		});

		autoTable(doc, {
			head: [cols],
			body: rows,
		});

		doc.save(`${fileName}.pdf`);
	}

  getFrequency(frequence) {
    let output = "";
    switch (frequence) {
      case 7:
        output = "semanal"
        break;
      case 14:
          output = "quinzenal"
        break;
      case 21:
          output = "1x a cada 3 semanas"
        break;
      case 28:
          output = "1x a cada 4 semanas"
        break;
      case 35:
          output = "1x a cada 5 semanas"
        break;
      default:
          output = "(toda repetição)"
        break;
    }
    return output;
  }

   capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
